import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6887053a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }, null, -1))
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "card mt-2 mb-3" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-auto d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "photo text-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }),
  /*#__PURE__*/_createTextVNode("ผู้อนุมัติโครงการ:")
], -1))
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-certificate me-2" }),
  /*#__PURE__*/_createTextVNode("ตำแแหน่ง:")
], -1))
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "list-group" }
const _hoisted_18 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_20 = { class: "text-truncate" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "badge bg-danger rounded-pill"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-bell" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "badge bg-success rounded-pill"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-check" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasComponent = _resolveComponent("BaseOffcanvasComponent")!

  return (_openBlock(), _createBlock(_component_BaseOffcanvasComponent, {
    ref: "commentOffcanvas",
    placement: "right",
    onHidden: _ctx.enjoinRedirect
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("การสั่งการ/เร่งรัดโครงการ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "photo-image",
                    src: _ctx.project?.projectApprovement?.ministerPhoto,
                    width: "60",
                    height: "70",
                    alt: "preview"
                  }, null, 8, _hoisted_8)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.project?.projectApprovement?.ministerName), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.project?.projectApprovement?.ministerPosition), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          (_ctx.enjoins?.length === 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                _hoisted_19,
                _createTextVNode("ไม่มีข้อมูล ")
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.enjoins, (enjoin, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "list-group-item d-flex justify-content-between align-items-start"
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.enjoinClick(enjoin.id)), ["stop","prevent"])
                    }, [
                      _hoisted_22,
                      _createTextVNode(_toDisplayString(enjoin.title), 1)
                    ], 8, _hoisted_21)
                  ]),
                  (enjoin.answers.length === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_25))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_28))
                ]))
              }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHidden"]))
}